export const themeName = 'deliTheme';
export const themeCssVars = {
  'font-size': '12px',
  'body-background': '#f4f6f8',
  'padding-md': '12px',
  'padding-lg': '12px',
  height: '32px',
  'height-sm': '26px',
  'text-color': 'rgba(0,0,0,0.65)',
  // 切换app
  'app-switch-background-color': '#fff',
  // 菜单
  'menu-expand-background-color': '#f4f6f8',
  'menu-item-margin-top': 0,
  'menu-item-height': '40px',
  // 表格
  'table-thead-height': '36px',
  'table-tr-height': '36px',
  'table-thead-bg': '#f4f6f8',
  'table-tr-stripe-bg': '#e6efff',
  'table-tr-checked-bg': '#cadfff',
  'table-tr-hover-bg': '#cadfff',
  // 解决 vxe-table 内存泄漏
  'table-config': {
    isHover: false
  },
  // 下拉选择
  'select-line-height': '22px',
  'primary-color-hover': '#035DFF',
  'primary-color-focus': '#035DFF',
  'primary-color-active': '#035DFF',
  'padding-xxs': '4px',
  'margin-xxs': '4px',
  'padding-sm': '12px',
  'primary-color-rgb': '3,93,255'
};
